import React from "react";
import { useContext } from "react";
import AuthContext from 'store/AuthContext';
import AccountService from "services/AccountService"
import {PasswordField} from './PasswordField';
import { Container, FormLabel, FormControl, Button } from 'react-bootstrap';
import { useLanguage } from "pages/dimension/LanguageContext";

export const ChangePassword = () => {
    const authCtx = useContext(AuthContext);
    const langCtx = useLanguage();

    const [inProgress, setInProgress] = React.useState(false)

    const [message, setMessage] = React.useState<string | null>(null);
    const [error, setError] = React.useState<string | null>(null);

    const currPasswordInputRef = React.useRef<HTMLInputElement>(null);
    const newPasswordInputRef = React.useRef<HTMLInputElement>(null);
    const confPasswordInputRef = React.useRef<HTMLInputElement>(null);

    function changePasswordClick() {
        console.log("changePasswordClick")
        setMessage(null);
        setError(null);
        if (!currPasswordInputRef.current!.value) {
            setError("Enter the current password");
            return;
        }
        if (!newPasswordInputRef.current!.value) {
            setError("Enter the new password");
            return;
        }
        if (newPasswordInputRef.current!.value != confPasswordInputRef.current!.value) {
            setError("New passwords don't match");
            return;
        }
        setMessage("Changing password..");
        setInProgress(true)
        AccountService.updateCurrentAccountPassword(currPasswordInputRef.current!.value, newPasswordInputRef.current!.value)
            .then((res: any) => {
                    currPasswordInputRef.current!.value = "";
                    newPasswordInputRef.current!.value = "";
                    confPasswordInputRef.current!.value = "";
                    setMessage("Password changed");
                })
            .catch((error: string) => {
                setMessage(null);
                setError(`Failed to change password: ${error}`);
            })
            .finally(()=> {
                setInProgress(false)
            })
    }

    if (!authCtx.account.valid()) {
        return (
            <b>Logged out.</b>
        );
    }

    return (
        <Container className="d-flex flex-column">
            <div style={{ marginBottom: "10px"}}>
                <FormLabel htmlFor="passwordInput">{langCtx.translate('Current Password')}</FormLabel>
                <FormControl id="passwordInput" type="password" ref={currPasswordInputRef} />
                <FormLabel htmlFor="newPasswordInput">{langCtx.translate('New Password')}</FormLabel>
                <FormControl id="newPasswordInput" type="password" ref={newPasswordInputRef} />
                <FormLabel htmlFor="confNewPasswordInput">{langCtx.translate('Confirm New Password')}</FormLabel>
                <FormControl id="confNewPasswordInput" type="password" ref={confPasswordInputRef} />
            </div>
            { message && (<p className="text-secondary">{message}</p>)}
            { error && (<p className="text-danger">{error}</p>)}
            <Button variant="warning" disabled={inProgress} style={{ width: "200px"}} onClick={changePasswordClick}>{langCtx.translate('Change Password')}</Button>
        </Container>
    );
};
